export const avatarGroupStyles = {
  '& .MuiAvatarGroup-avatar': {
    width: '40px',
    height: '40px',
    marginLeft: '-8px',
    fontSize: '14px',
  },
  '& .MuiAvatarGroup-avatar.MuiAvatar-root': {
    width: '40px',
    height: '40px',
  },
};

export const avatarWrapperStyles = {
  marginLeft: '-8px',
};
